import { render, staticRenderFns } from "./user_tab1.vue?vue&type=template&id=3d4bed06&scoped=true"
import script from "./user_tab1.vue?vue&type=script&lang=js"
export * from "./user_tab1.vue?vue&type=script&lang=js"
import style0 from "./user_tab1.vue?vue&type=style&index=0&id=3d4bed06&prod&scoped=true&lang=less"
import style1 from "./user_tab1.vue?vue&type=style&index=1&id=3d4bed06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4bed06",
  null
  
)

export default component.exports